<template>
  <div :style="{ height, width }" id="EchartsGG" ref="docement"></div>
</template>
<script>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";
export default {
  name: "baseBar",
  props: {
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    left1Data: {
      type: Object,
      default: () => {},
    },
  },
  data: function () {
    return {
      echartsData: {
        size: 21,
        list: [
          { dysl: "70", mc: "1月", dm: "01", sysl: "12.1" },
          { dysl: "75", mc: "2月", dm: "02", sysl: "8.1" },
          { dysl: "40", mc: "3月", dm: "03", sysl: "28.5" },
          { dysl: "70", mc: "4月", dm: "04", sysl: "27.6" },
          { dysl: "70", mc: "5月", dm: "04", sysl: "30.6" },
          { dysl: "70", mc: "6月", dm: "04", sysl: "35.6" },
          { dysl: "70", mc: "7月", dm: "04", sysl: "37.6" },
        ],
      },
    };
  },
  mounted() {
    this.loadEchartsAnimate();
  },
  methods: {
    chartsRelativeSize(percent, derection) {
      var windowW = this.$refs.docement.offsetWidth;
      var windowH = this.$refs.docement.offsetHeight;
      var r = 0;
      if ("h" === derection) {
        r = (percent * windowH) / 100;
      } else {
        r = (percent * windowW) / 100;
      }
      return r;
    },
    loadEchartsAnimate() {
      var that = this;
      var echarts = require("echarts");
      var myCharts = echarts.init(document.getElementById("EchartsGG"));
      var option = {
        color: ["#407FFF", "#00FFBA"],
        tooltip: {
          trigger: "axis",
          textStyle: {
            color: "#000",
            fontSize: "40",
          },
          //   formatter: function (params) {
          //       var arr = [];
          //       params.forEach(function (item) {
          //           var N=item.seriesName;
          //           var V = '';
          //           if(item.value>100000000){//亿
          //               V += (item.value/100000000).toFixed(1) + '亿';
          //           }else if( item.value>10000){//万
          //               V += (item.value/10000).toFixed(1) + '万';
          //           }else{
          //               V += item.value;
          //           }
          //           var a = {name:N,value:V};
          //           arr.push(a);
          //       });
          //       var num = '';
          //       arr.forEach(function (item) {
          //           num += item.name+":"+item.value+"<br/>";
          //       });
          //       return params[0].name +"<br>"+ num;
          //   }
        },
        grid: {
          left: "5%",
          right: "5%",
          bottom: "10%",
          top: "10%",
          containLabel: true,
        },
        title: {
          text: "单位：℃", // 替换为您所需的标题文本
          textStyle: {
            color: "#D6FFFF", // 文本颜色
            fontSize: 25, // 字体大小
            // fontWeight: "bold", // 字体粗细
          },
          // left: "left", // 标题水平居中
          top: "1%", // 标题距离顶部的距离，可根据需要调整
          left: "7%",
        },
        // legend: {
        //   orient: "horizontal",
        //   top: "10px",
        //   right: "0",
        //   itemWidth: 26,
        //   itemHeight: 12,
        //   icon: "rect",
        //   textStyle: {
        //     color: "#fff",
        //     fontSize: "12px",
        //     padding: [5, 0, 0, 0],
        //   },
        //   data: ["水变化量", "肥料变化量"],
        //   z: 10001,
        // },
        xAxis: [
          {
            type: "category",
            axisLine: {
              lineStyle: {
                type: "solid",
                color: "#1F4457", //左边线的颜色
                width: "1", //坐标线的宽度
              },
            },
            axisLabel: {
              textStyle: {
                color: "#fff", //坐标值得具体的颜色,
                fontSize: "40",
              },
              interval: 0,
            },
            axisTick: false,
            data: [],
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLine: {
              show: true,
              lineStyle: {
                type: "solid",
                color: "#20465A", //左边线的颜色
                width: "2", //坐标线的宽度
              },
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#e6e6e6", //坐标值得具体的颜色,
                fontSize: "40",
              },
            },
            axisTick: false,
            splitLine: {
              //坐标轴在grid区域中的分隔线（网格中的横线）
              show: true,
              lineStyle: {
                color: "#104557",
                width: 1,
                type: "solid",
              },
            },
          },
        ],
        series: [
          {
            name: "数据",
            type: "bar",
            barGap: 0,
            barWidth: 30,
            data: [],
            itemStyle: {
              normal: {
                // //这里设置柱形图圆角 [左上角，右上角，右下角，左下角]
                // barBorderRadius:[5, 5, 5, 5],
                borderColor: "#00E3C0",
                color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                  { offset: 0, color: "#0DA28B" },
                  { offset: 1, color: "rgba(0,227,192,0)" },
                ]),
              },
            },
          },
          // {
          //   name: "肥料变化量",
          //   type: "bar",
          //   barGap: 0,
          //   barWidth: 20,
          //   data: [],
          //   itemStyle: {
          //     normal: {
          //       //这里设置柱形图圆角 [左上角，右上角，右下角，左下角]
          //       // barBorderRadius:[5, 5, 5, 5],
          //       borderColor: "#3CB4B5",
          //       color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
          //         { offset: 0, color: "#45FFFD" },
          //         { offset: 1, color: "rgba(69,255,253,0)" },
          //       ]),
          //     },
          //   },
          // },
        ],
      };
      for (var i = 0; i < this.echartsData.list.length && i < 5; i++) {
        option.xAxis[0].data.push(that.echartsData.list[i].mc);
        option.series[0].data.push(that.echartsData.list[i].sysl);
        //   option.series[1].data.push(that.echartsData.list[i].dysl);
      }
      myCharts.setOption(option);

      if (window.hbfxInterval) {
        clearInterval(window.hbfxInterval);
      }
      window.hbfxIndex = 0;
      window.hbfxInterval = setInterval(function () {
        option.xAxis[0].data.shift();
        option.xAxis[0].data.push(
          that.echartsData.list[window.hbfxIndex % that.echartsData.list.length]
            .mc
        );

        option.series[0].data.shift();
        option.series[0].data.push(
          that.echartsData.list[window.hbfxIndex % that.echartsData.list.length]
            .sysl
        );

        // option.series[1].data.shift();
        // option.series[1].data.push(
        //   that.echartsData.list[window.hbfxIndex % that.echartsData.list.length]
        //     .dysl
        // );

        myCharts.setOption(option);
        window.hbfxIndex++;
      }, 2000);
    },
  },
};
</script>
<style lang="less">
.min-body {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #010827;
}
</style>
